import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectFilters, selectHotels, selectLoading } from '@results/store/results.selector';
import { IFilters } from '@results/store/results.state';
import { selectContextCore, selectContextLanding } from '@store/context/context.selector';
import { IContextCore } from '@store/context/context.state';
import { IHotelsAppState } from '@store/index';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'am-filters-menu',
  templateUrl: './filters-menu.component.html',
  styleUrls: ['./filters-menu.component.scss'],
})
export class FiltersMenuComponent implements OnInit, OnDestroy {
  @Input() map = false;

  public isLanding$: Observable<boolean>;
  public filters$: Observable<IFilters>;
  public loading$: Observable<boolean>;
  public hotels$: Observable<any>;
  public context$: Observable<IContextCore>;
  public unSubscribe$ = new Subject<void>();

  @Output() showFilters: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private store$: Store<IHotelsAppState>) {
    this.context$ = this.store$.pipe(select(selectContextCore), takeUntil(this.unSubscribe$));
    this.filters$ = this.store$.pipe(select(selectFilters), takeUntil(this.unSubscribe$));
    this.loading$ = this.store$.pipe(select(selectLoading), takeUntil(this.unSubscribe$));
    this.hotels$ = this.store$.pipe(select(selectHotels), takeUntil(this.unSubscribe$));
    this.isLanding$ = this.store$.pipe(select(selectContextLanding), takeUntil(this.unSubscribe$));
  }

  ngOnInit(): void {}

  public toggleShowFilters() {
    this.showFilters.emit(true);
  }
  public ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.unsubscribe();
  }
}
